import City from "../../models/common/city.model";
import Diversity from "../../models/common/diversity.model";
import ExperienceTime from "../../models/common/experience-time.model";
import HireType from "../../models/common/hire-type.model";
import ProfessionalMoment from "../../models/common/professional-moment.model";
import Proficiency from "../../models/common/proficiency.model";
import { SignUpReasonInterface } from "../../models/common/sign-up-reason.model";
import Skill from "../../models/common/skill.model";
import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { GlobalTypes } from "../global-types";
import { CommonActionTypes, CommonState, INITIAL_STATE } from "./common-types";


const reduxBuilder = new ReducerBuilder<CommonState>(INITIAL_STATE);

reduxBuilder.addReducer(GlobalTypes.CLEAR, () => {
    return INITIAL_STATE;
});

/* ==================== Experience Time ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_EXPERIENCE_TIME,
    (state) => {
        state.experienceTimeData.loading = true;
        state.experienceTimeData.error = null;
    }
);

reduxBuilder.addMutableReducer<ExperienceTime[]>(
    CommonActionTypes.FETCH_EXPERIENCE_TIME_SUCCESS,
    (state, payload) => {
        state.experienceTimeData.loading = false;
        state.experienceTimeData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_EXPERIENCE_TIME_ERROR,
    (state, error) => {
        state.experienceTimeData.loading = false;
        state.experienceTimeData.error = error;
    }
);

/* ==================== Diversity ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_DIVERSITY,
    (state) => {
        state.diversityData.loading = true;
        state.diversityData.error = null;
    }
);

reduxBuilder.addMutableReducer<Diversity[]>(
    CommonActionTypes.FETCH_DIVERSITY_SUCCESS,
    (state, payload) => {
        state.diversityData.loading = false;
        state.diversityData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_DIVERSITY_ERROR,
    (state, error) => {
        state.diversityData.loading = false;
        state.diversityData.error = error;
    }
);

/* ==================== Proficiency ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_PROFICIENCY,
    (state) => {
        state.proficiencyData.loading = true;
        state.proficiencyData.error = null;
    }
);

reduxBuilder.addMutableReducer<Proficiency[]>(
    CommonActionTypes.FETCH_PROFICIENCY_SUCCESS,
    (state, payload) => {
        state.proficiencyData.loading = false;
        state.proficiencyData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_PROFICIENCY_ERROR,
    (state, error) => {
        state.proficiencyData.loading = false;
        state.proficiencyData.error = error;
    }
);

/* ==================== HireType ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_HIRE_TYPE,
    (state) => {
        state.hireTypeData.loading = true;
        state.hireTypeData.error = null;
    }
);

reduxBuilder.addMutableReducer<HireType[]>(
    CommonActionTypes.FETCH_HIRE_TYPE_SUCCESS,
    (state, payload) => {
        state.hireTypeData.loading = false;
        state.hireTypeData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_HIRE_TYPE_ERROR,
    (state, error) => {
        state.hireTypeData.loading = false;
        state.hireTypeData.error = error;
    }
);

/* ==================== Degree ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_DEGREE,
    (state) => {
        state.degreeData.loading = true;
        state.degreeData.error = null;
    }
);

reduxBuilder.addMutableReducer<HireType[]>(
    CommonActionTypes.FETCH_DEGREE_SUCCESS,
    (state, payload) => {
        state.degreeData.loading = false;
        state.degreeData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_DEGREE_ERROR,
    (state, error) => {
        state.degreeData.loading = false;
        state.degreeData.error = error;
    }
);

/* ==================== Professional Moment ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_PROFESSIONAL_MOMENT,
    (state) => {
        state.professionalMomentData.loading = true;
        state.professionalMomentData.error = null;
    }
);

reduxBuilder.addMutableReducer<ProfessionalMoment[]>(
    CommonActionTypes.FETCH_PROFESSIONAL_MOMENT_SUCCESS,
    (state, payload) => {
        state.professionalMomentData.loading = false;
        state.professionalMomentData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_PROFESSIONAL_MOMENT_ERROR,
    (state, error) => {
        state.professionalMomentData.loading = false;
        state.professionalMomentData.error = error;
    }
);

/* ==================== Skill ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_SKILL,
    (state) => {
        state.skillData.loading = true;
        state.skillData.error = null;
    }
);

reduxBuilder.addMutableReducer<Skill[]>(
    CommonActionTypes.FETCH_SKILL_SUCCESS,
    (state, payload) => {
        state.skillData.loading = false;
        state.skillData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_SKILL_ERROR,
    (state, error) => {
        state.skillData.loading = false;
        state.skillData.error = error;
    }
);

/* ==================== City ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_CITY_DATA,
    (state) => {
        state.cityData.loading = true;
        state.cityData.error = null;
    }
);

reduxBuilder.addMutableReducer<City[]>(
    CommonActionTypes.FETCH_CITY_DATA_SUCCESS,
    (state, payload) => {
        state.cityData.loading = false;
        state.cityData.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_CITY_DATA_ERROR,
    (state, error) => {
        state.cityData.loading = false;
        state.cityData.error = error;
    }
);

/* ==================== SignUp Reasons ==================== */

reduxBuilder.addMutableReducer(
    CommonActionTypes.FETCH_SIGNUP_REASONS,
    (state) => {
        state.signupReasons.loading = true;
        state.signupReasons.error = null;
    }
);

reduxBuilder.addMutableReducer<SignUpReasonInterface[]>(
    CommonActionTypes.FETCH_SIGNUP_REASONS_SUCCESS,
    (state, payload) => {
        state.signupReasons.loading = false;
        state.signupReasons.data = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CommonActionTypes.FETCH_SIGNUP_REASONS_ERROR,
    (state, error) => {
        state.signupReasons.loading = false;
        state.signupReasons.error = error;
    }
);

/* ===================================================== */

export default reduxBuilder.build();
